import {Outlet} from "react-router-dom";
import styles from "./Auth.module.scss";
import defaultBg from "../../assets/images/auth/default-auth-bg.png";
import useAppSelector from "../../hooks/useAppSelector";
import {getImageUrlForContent} from "../../helpers/image.helper";

export const Auth = () => {

    const {content} = useAppSelector(state => state.siteContentSlice);

    return (
        <div className={styles.page} style={{backgroundImage: `url(${getImageUrlForContent(content.loginBackgroundPath) || defaultBg})`}}>
            <div className={styles.filter}></div>
            <div className={styles.box}>
                <Outlet/>
            </div>
        </div>
    )
}

export default Auth;